import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapFinancePayableItinerarySearchParams,
  mapFinancePayableItinerarySearchResult,
  mapFinancePayablePrepaymentSummary,
  mapFinancePayableSettlementSummary,
  type FinancePayablePrepaymentSummaryRaw,
  type FinancePayableSettlementSummaryRaw,
  type FinancePayableWorkspaceListRaw,
} from "../api/adapters";
import type {
  FinancePayableItinerarySearchResult,
  FinancePayablePrepaymentSummary,
  FinancePayableSettlementSummary,
} from "../types";

/** 按线路关键字搜团，复用确认件工作区列表接口。 */
export async function searchFinancePayableItineraries(
  keyword: string,
): Promise<FinancePayableItinerarySearchResult> {
  const response = await httpClient.get<ApiEnvelope<FinancePayableWorkspaceListRaw>>("/fulfillment-orders", {
    params: mapFinancePayableItinerarySearchParams(keyword),
  });
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("确认件列表接口返回了无效数据");
  }
  return mapFinancePayableItinerarySearchResult(response.data.data);
}

/** 按行程 ID 读取这个团按结算主体一行的应付汇总。 */
export async function fetchFinancePayableSettlementSummary(
  itineraryId: string,
): Promise<FinancePayableSettlementSummary> {
  const response = await httpClient.get<ApiEnvelope<FinancePayableSettlementSummaryRaw>>(
    `/finance-payables/itineraries/${encodeURIComponent(itineraryId)}/settlement-summary`,
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("应付汇总接口返回了无效数据");
  }
  return mapFinancePayableSettlementSummary(response.data.data);
}

/** 按行程 ID 读取团还没有确认件时的预付款汇总：团名、服务日期取行程本身，加预付款行与合计。 */
export async function fetchFinancePayablePrepaymentSummary(
  itineraryId: string,
): Promise<FinancePayablePrepaymentSummary> {
  const response = await httpClient.get<ApiEnvelope<FinancePayablePrepaymentSummaryRaw>>(
    `/finance-payables/itineraries/${encodeURIComponent(itineraryId)}/prepayment-summary`,
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("预付款汇总接口返回了无效数据");
  }
  return mapFinancePayablePrepaymentSummary(response.data.data);
}
